import React from 'react';

import Icon from '../../../AppIcon';
import Image from '../../../AppImage';
import Button from '../../../ui/Button';

const OpportunityCard = ({ opportunity }) => {
  const getPriorityColor = (priority) => {
    const colors = {
      high: 'bg-error/10 text-error border-error/20',
      medium: 'bg-warning/10 text-warning border-warning/20',
      low: 'bg-success/10 text-success border-success/20'
    };
    return colors?.[priority] || colors?.medium;
  };

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-success/10 text-success',
      pending: 'bg-warning/10 text-warning',
      closed: 'bg-muted text-muted-foreground',
      draft: 'bg-primary/10 text-primary'
    };
    return colors?.[status] || colors?.pending;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          {opportunity?.logo && (
            <Image
              src={opportunity?.logo}
              alt={opportunity?.logoAlt}
              className="w-12 h-12 rounded-lg object-cover"
            />
          )}
          <div>
            <h4 className="font-semibold text-foreground">{opportunity?.title}</h4>
            <p className="text-sm text-muted-foreground">{opportunity?.company}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(opportunity?.priority)}`}>
            {opportunity?.priority}
          </span>
          <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(opportunity?.status)}`}>
            {opportunity?.status}
          </span>
        </div>
      </div>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {opportunity?.description}
      </p>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="DollarSign" size={14} />
            <span>{opportunity?.budget}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>{opportunity?.deadline}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="MapPin" size={14} />
            <span>{opportunity?.location}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {opportunity?.tags?.slice(0, 2)?.map((tag, index) => (
            <span key={index} className="px-2 py-1 text-xs bg-muted text-muted-foreground rounded">
              {tag}
            </span>
          ))}
          {opportunity?.tags?.length > 2 && (
            <span className="text-xs text-muted-foreground">
              +{opportunity?.tags?.length - 2} more
            </span>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Button variant="outline" size="sm">
            <Icon name="Eye" size={14} className="mr-1" />
            View
          </Button>
          <Button variant="default" size="sm">
            <Icon name="ArrowRight" size={14} className="mr-1" />
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OpportunityCard;